import { openModal } from '@core/components/ModalStack';
import { AddEditChecklistStepModalProps } from './AddEditChecklistStepModal';

export async function openAddEditChecklistStep(props: AddEditChecklistStepModalProps) {
  const { AddEditChecklistStepModal } = await import('./AddEditChecklistStepModal');

  openModal(AddEditChecklistStepModal, props);
}
